import { render } from "./saved-jobs.vue?vue&type=template&id=a8a1d5e6"
import script from "./saved-jobs.vue?vue&type=script&lang=js"
export * from "./saved-jobs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__